// Display metadata for the five departmental agents. Maps the backend `name`
// to a human label (note "IT" stays uppercase), an icon, a short rail blurb,
// and a longer empty-state hint. Falls back gracefully for unknown agents.
const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s)

const META = {
  people: { label: 'People', icon: 'groups', blurb: 'HR, time off, benefits', hint: 'time off, benefits, and company policies' },
  finance: { label: 'Finance', icon: 'payments', blurb: 'Budgets & reimbursements', hint: 'budgets, reimbursements, and spend' },
  it: { label: 'IT', icon: 'dns', blurb: 'Access, devices, software', hint: 'access requests, devices, and software' },
  legal: { label: 'Legal', icon: 'gavel', blurb: 'Contracts & compliance', hint: 'contracts, compliance, and policies' },
  sales: { label: 'Sales', icon: 'trending_up', blurb: 'Pipeline & accounts', hint: 'pipeline, accounts, and quotas' },
}

export function agentMeta(name) {
  return META[name] || { label: cap(name), icon: 'smart_toy', blurb: '', hint: 'anything you need' }
}
